// @flow
import React, { Component } from 'react'

type Props = {
  title: string,
  tooltip: {
    pos: {
      x: number,
      y: number,
    },
    display: boolean,
    data: {
      key: string,
      value: string,
    },
  },
}

type State = {
  width: number,
  height: number,
}

export default class ToolTip extends Component<Props, State> {
  state = {
    width: 120,
    height: 70,
  }

  render() {
    const { width, height } = this.state
    const { tooltip, title } = this.props
    const { x, y } = tooltip.pos

    const visibility = tooltip.display ? 'visible' : 'hidden'

    const transformText = `translate(${width / 2},${height / 2 - 5})`

    let transform = `translate(${x - width / 2},${Math.round(y) + 20})`

    if (tooltip.display) {
      if (y > height) {
        transform = `translate(${x - width / 2},${y - height - 20})`
      }
    }

    return (
      <g transform={transform}>
        <rect
          is
          width={width}
          height={height}
          rx="2"
          ry="2"
          visibility={visibility}
          fill="#fff"
          stroke="#000"
          strokeWidth="3"
          opacity=".95"
        />
        <text is visibility={visibility} transform={transformText}>
          <tspan
            is
            x="0"
            text-anchor="middle"
            font-size="14px"
          >{`${tooltip.data.value}  ${title}`}</tspan>
          <tspan is x="0" text-anchor="middle" dy="25" font-size="12px">
            {tooltip.data.key}
          </tspan>
        </text>
      </g>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Charts/ToolTip.js